export function sortBy<T>(list: T[], property: keyof T): T[] {
  return list.sort((a, b) => (a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0));
}
